var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4143 2.58567C17.0393 2.21067 16.5306 2 16.0002 2C15.4699 2 14.9612 2.21067 14.5861 2.58567L13.7046 3.4672L16.5328 6.29539L17.4143 5.41387C17.7893 5.0388 18 4.53014 18 3.99977C18 3.46939 17.7893 2.96073 17.4143 2.58567ZM15.7244 7.10378L12.8962 4.27558L3.63906 13.5327C3.16885 14.0027 2.82319 14.5825 2.63334 15.2196L2.02381 17.2653C1.99439 17.364 1.99219 17.4689 2.01746 17.5687C2.04273 17.6686 2.09453 17.7598 2.16737 17.8326C2.24021 17.9055 2.33139 17.9573 2.43125 17.9825C2.53111 18.0078 2.63595 18.0056 2.73467 17.9762L4.78039 17.3667C5.41752 17.1768 5.99728 16.8312 6.46725 16.3609L15.7244 7.10378Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.927f570b1504c227bafb072d2b821047.svg";
export { ForwardRef as ReactComponent };